import Phaser from 'phaser';
import { GameScene } from './GameScene';
import { activePhysicsIsolationPreset, PHYSICS_ISOLATION_PRESETS } from './physicsIsolationPresets';
import { GAME_HEIGHT, GAME_WIDTH } from './worldDimensions';

export { GAME_HEIGHT, GAME_WIDTH } from './worldDimensions';
const physicsPreset = PHYSICS_ISOLATION_PRESETS[activePhysicsIsolationPreset()];

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-canvas',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  transparent: true,
  scene: [GameScene],
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: physicsPreset.gravityY },
      enableSleeping: true,
      positionIterations: 12,
      velocityIterations: 10,
      constraintIterations: 4,
    },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
  },
};
